__turbopack_context__.v({
  "field": "field-module__K42O2q__field",
});
